import { Text } from "recharts";
import { rechartsConfig } from "./BaseChart";

type CustomXAxisTickProps = {
  x?: number;
  y?: number;
  width?: number;
  payload?: { value?: unknown };
  angle?: number;
  textAnchor?: "start" | "middle" | "end" | "inherit";
  verticalAnchor?: "start" | "middle" | "end";
  showTooltip?: boolean;
  maxChars?: number;
};

const DEFAULT_MAX_CHARS = 12;
const DEFAULT_WIDTH = 100;

const truncateLabel = (label: string, maxChars: number) => {
  if (!label) return "";
  if (label.length <= maxChars) return label;
  const sliceLen = Math.max(1, maxChars - 1);
  return `${label.slice(0, sliceLen)}…`;
};

const CustomXAxisTick: React.FC<
  CustomXAxisTickProps & Record<string, unknown>
> = (props) => {
  const {
    x,
    y,
    width = DEFAULT_WIDTH,
    payload,
    angle,
    textAnchor = "end",
    verticalAnchor = "start",
    showTooltip = true,
    maxChars = DEFAULT_MAX_CHARS,
  } = props;

  const rawLabel = payload?.value ?? "";
  const fullLabel = String(rawLabel);
  const displayLabel = truncateLabel(fullLabel, maxChars);

  return (
    <g style={{ pointerEvents: "all" }}>
      {showTooltip && fullLabel ? <title>{fullLabel}</title> : null}
      <Text
        x={x}
        y={y}
        width={width}
        angle={angle}
        textAnchor={textAnchor}
        verticalAnchor={verticalAnchor}
        fill={rechartsConfig.xAxis.tick.fill}
        fontSize={rechartsConfig.xAxis.tick.fontSize}
        fontFamily={rechartsConfig.xAxis.tick.fontFamily}
        maxLines={1}
        style={{ pointerEvents: "all", cursor: "default" }}
      >
        {displayLabel}
      </Text>
    </g>
  );
};

export default CustomXAxisTick;
